export default __webpack_public_path__ + "static/media/welcome_condutores.ac6cffa2.png";